import dayjs from "dayjs";
import { SiteEvent } from "../types/siteEvent";

const filterSiteEventsForDate = (
  date: Date,
  siteEvents?: SiteEvent[]
): SiteEvent[] | undefined => {
  return siteEvents?.filter(
    (siteEvent) =>
      dayjs(siteEvent.date).format("YYYY-MM-DD") ===
      dayjs(date).format("YYYY-MM-DD")
  );
};

export { filterSiteEventsForDate };
